import React, { useEffect, useRef, useState } from "react";

import { useAppType } from "utils";

import { Col, Row, Typography } from "components";

export const ProgressBarSteps = ({ headers = null, totalSteps, currentStep, startStep, className }) => {
  const interval = useRef(null);
  const [displayedValue, setDisplayedValue] = useState(startStep ? (parseFloat(startStep) / parseFloat(totalSteps)) * 100 : 0);

  const { mobile } = useAppType();

  const currentPercent = (parseFloat(currentStep) / parseFloat(totalSteps)) * 100;

  const calcSegmentWidth = (i) => {
    const eachStep = 100 / totalSteps;
    const minThreshold = eachStep * i;
    const maxThreshold = eachStep * (i + 1);
    const thisStepProgress = ((displayedValue - minThreshold) / (maxThreshold - minThreshold)) * 100;

    return displayedValue >= minThreshold ? thisStepProgress : 0;
  };

  useEffect(() => {
    interval.current = setInterval(() => {
      setDisplayedValue((val) => {
        if (val >= currentPercent) {
          return currentPercent;
        }
        return val + 1;
      });
      clearInterval(interval.current);
    }, 1000 / currentPercent);
  }, [currentPercent, displayedValue]);

  useEffect(() => {
    if (parseFloat(displayedValue) >= currentPercent) {
      setDisplayedValue(currentPercent);
      clearInterval(interval.current);
    }
  }, [displayedValue, currentPercent]);

  return (
    <Row className={`${className || `${mobile ? "" : "margin-top-100"} margin-bottom-${mobile ? "100" : "150"}`}`}>
      <Col>
        <div className="step-progress">
          {Array(totalSteps)
            .fill(null)
            .map((_, i) => (
              <div className="step-container" key={i}>
                {headers && (
                  <Typography variant="h3" color={currentStep === i + 1 ? "green-400" : "grey-600"} className="margin-bottom-50">
                    {headers[i]}
                  </Typography>
                )}
                <div className="step">
                  <span style={{ width: `${calcSegmentWidth(i)}%` }} />
                </div>
              </div>
            ))}
        </div>
      </Col>
    </Row>
  );
};

export default ProgressBarSteps;
